import React from "react";

const AdminSettings = () => {
  return (
    <div>
      <h1>Admin Settings</h1>
      <p>Content of the all charts admin settings page...</p>
    </div>
  );
};

export default AdminSettings;
